// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store/store.js'
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueResource from 'vue-resource';
import './iconfont/iconfont.css';
import Blob from './excel/Blob.js'
import Export2Excel from './excel/Export2Excel.js'
Vue.config.productionTip = true;
Vue.config.devtools = true;
import "babel-polyfill";
// import Print from"./plugs/print.js";
Vue.use(VueResource);
/* eslint-disable no-new */
Vue.use(ElementUI);
// Vue.use(Blob);
// Vue.use(Export2Excel);
//Vue.http.options.emulateJSON = true;
/******************拦截器设置请参考这部分(开始)******************/
Vue.http.interceptors.push((request, next)  =>{
  next((response) => {
    if(response.status === 0){
      window.location.href ="/#/";
    }
    if(response.body.status === 401 ){
      router.push('/');
      store.commit('$_removeStorage');
      Vue.prototype.$message.warning('会话已过期！请重新登录！');
     ElementUI.Loading.service().close();
    }
    else{
      return response;
    }
  });
});
router.beforeEach((to, from, next) => {
  if(to.params.keepAlive){
    from.meta.keepAlive = true;
    to.meta.keepCount = true;
  }else{
    if(to.meta.keepCount){
      to.meta.keepCount = false;
    }else{
      from.meta.keepAlive = false;
    }
  }
  //判断是否为建设单位
  if (to.matched.some(m => m.meta.construction)) {
    if (window.localStorage.isLogin === '100') {
      next()
    } else if (to.path !== '/') {
      next({path: '/'});
      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
    }
  } else if(to.matched.some(m => m.meta.design)){//判断是否为设计单位
    if (window.localStorage.isLogin === '200') {
      next()
    } else if (to.path !== '/') {
      next({path: '/'});
      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
    }
  }else if(to.matched.some(m => m.meta.draw)){//判断是否为审图
    if (window.localStorage.isLogin === '300') {
      next()
    } else if (to.path !== '/') {
      next({path: '/'});
      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
    }
  }else if(to.matched.some(m => m.meta.supervise)){//判断是否为审图
    if (window.localStorage.isLogin === '300') {
      next()
    } else if (to.path !== '/') {
          next({path: '/'});
          Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
    }
  }else if(to.path === '/autoLogin'){
    // next({path: '/autoLogin'})
    next()
  }else{
    next()
  }
  document.querySelector('.el-loading-mask')&&document.querySelector('.el-loading-mask').remove()
});
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js